/* TT2 homepage reveals — IntersectionObserver, unobserve after fire.
   Guarded so repeated script tags (one per section) init exactly once. */
(function () {
  if (window.__tt2Init) return;
  window.__tt2Init = true;
  function init() {
    var els = document.querySelectorAll('.tt2-reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('tt2-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('tt2-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Tool tile clicks → GA4 select_promotion (2026-09-15). window.gtag is the store's
   Google & YouTube app tag; guarded so a missing tag is a no-op, never an error. */
(function () {
  if (window.__tt2Tiles) return;
  window.__tt2Tiles = true;
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-tile]') : null;
    if (!a || typeof window.gtag !== 'function') return;
    window.gtag('event', 'select_promotion', {
      promotion_name: a.getAttribute('data-tile'),
      creative_name: a.getAttribute('data-placement') || 'bento',
      creative_slot: 'homepage_hero',
      location_id: 'tengtoolsusa.com/'
    });
  }, { passive: true });
})();
